/**
 * The ported guides funnel readers to the report tool + calculator. Those live
 * on the apex domain (biedradar.nl) — NEVER a `get.`/other subdomain — so the
 * funnel links resolve to the apex regardless of any build env. (We deliberately
 * don't read VITE_CONSUMER_ORIGIN anymore: it was injecting a `get.` subdomain
 * into every CTA.)
 */
export const CONSUMER_ORIGIN = "https://biedradar.nl";

export const consumerLink = (path: string): string => `${CONSUMER_ORIGIN}${path}`;
